import React from 'react';
import { css, cx } from 'styled-system/css';
import { styled } from 'styled-system/jsx';
import { input } from 'styled-system/recipes';

import { Field as ArkField } from '@ark-ui/react/field';
import { Field } from '@shaojiang/components/ui/field';

import { filledInput } from './TextField';

const NativeSelect = styled(ArkField.Select, input);

const chevron = css({
  appearance: 'none',
  pr: '10',
  bgImage:
    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23888' stroke-width='2'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\")",
  bgRepeat: 'no-repeat',
  bgPosition: 'right 12px center',
});

type Props = {
  label: string;
  options: { value: string; label: string }[];
  error?: string;
  placeholder?: string;
  ref?: React.Ref<HTMLSelectElement>;
} & Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'size'>;

/** Native select styled like the Park UI input; works with react-hook-form's `register`. */
export default function SelectField({
  label,
  options,
  error,
  placeholder = 'Select ...',
  ...selectProps
}: Props) {
  return (
    <Field.Root invalid={!!error} className={css({ my: '2' })}>
      <Field.Label>{label}</Field.Label>
      <NativeSelect className={cx(filledInput, chevron)} defaultValue='' {...selectProps}>
        <option value='' disabled>
          {placeholder}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </NativeSelect>
      {error && <Field.ErrorText>{error}</Field.ErrorText>}
    </Field.Root>
  );
}
